<p class="title">
  {{ 'PAYMENTS.PAYPAL.TRANSACTION_HISTORY.DIALOG_TITLE' | translate }}
</p>

<table
  *ngIf="transactions$ | async as transactions"
  class="table"
  (scroll)="onScroll($event)"
>
  <app-paypal-transactions
    [transactions]="transactions"
    [parentContainer]="_elRef"
  ></app-paypal-transactions>

  <div *ngIf="loading$ | async">
    <i2g-loader></i2g-loader>
  </div>
</table>
